import { render, staticRenderFns } from "./ModalPriceChanged.vue?vue&type=template&id=2164321b&scoped=true"
import script from "./ModalPriceChanged.vue?vue&type=script&lang=js"
export * from "./ModalPriceChanged.vue?vue&type=script&lang=js"
import style0 from "./ModalPriceChanged.vue?vue&type=style&index=0&id=2164321b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164321b",
  null
  
)

export default component.exports